// * 输入检验 */
const mobileFormatter = /^((0\d{2,3}-\d{7,8})|(1[3584796]\d{9}))$/;
const emailFormatter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const codeFormatter = /^[0-9]{4}$/;
// var bankIdFormatter =  /^[0-9]*$/;

const handleAnchor = function(target) {
  if (!document.getElementById(target)) return;
  const top = document.getElementById(target).offsetTop;
  window.scrollTo({
    top: top - 20,
    behavior: 'smooth',
  });
};

const checkName = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('姓名不能为空'));
  }
  if (value.length > 20) {
    return callback(new Error('不能超过20个字符'));
  }
  callback();
};
const checkRemitterName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('汇款姓名不能为空'));
  }
  if (value.length > 20) {
    return callback(new Error('不能超过20个字符'));
  }
  callback();
};
const nickName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('昵称不能为空'));
  }

  if (value.length > 20) {
    return callback(new Error('不能超过20个字符'));
  }
  callback();
};

const checkBank = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('开户银行不能为空'));
  }
  callback();
};

const checkBankId = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('银行卡号不能为空'));
  }
  callback();
};

const inputNumber = e => {
  e.target.value = e.target.value.replace(/\D/g, '');
};

const checkExperience = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('设计经验不能为空'));
  }
  callback();
};
const checkAbility = (rule, value, callback) => {
  if (!value.length) {
    return callback(new Error('擅长类型不能为空'));
  }
  callback();
};

const checkMobileOrEmail = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号／邮箱不能为空'));
  }
  if (!mobileFormatter.test(value) && !emailFormatter.test(value)) {
    return callback(new Error('请输入有效的手机号／邮箱'));
  }
  callback();
};

const checkMobile = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('手机号码不能为空'));
  }

  if (!mobileFormatter.test(value)) {
    return callback(new Error('请输入有效的手机号码'));
  }
  callback();
};

const checkCode = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('验证码不能为空'));
  }
  if (!Number.isInteger(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (!codeFormatter.test(value)) {
    return callback(new Error('请输入四位验证码'));
  }
  callback();
};

const checkPass = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请输入密码'));
  }
  callback();
};

const checkPass2 = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('请再次输入密码'));
  }
  callback();
};

const checkEmail = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('邮箱不能为空'));
  }
  if (!emailFormatter.test(value)) {
    return callback(new Error('请输入有效的邮箱地址'));
  }
  callback();
};

const checkCompanyName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('公司名称不能为空'));
  }
  callback();
};

const checkCompanySize = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('公司规模不能为空'));
  }
  callback();
};
const checkCompanyPic = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('营业执照不能为空'));
  }
  callback();
};

const checkID = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('身份证不能为空'));
  }
  callback();
};

const checkProductTitle = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('作品名称不能为空'));
  }
  callback();
};

const checkProductUpload = (rule, value, callback) => {
  if (!value.length) {
    return callback(new Error('设计作品不能为空'));
  }
  callback();
};

const SingleCheck = {
  mobile(value) {
    if (!value) {
      return false;
    }
    if (!mobileFormatter.test(value)) {
      return false;
    }
    return true;
  },
  email(value) {
    if (!value) {
      return false;
    }
    if (!emailFormatter.test(value)) {
      return false;
    }
    return true;
  },
  product(value) {
    if (!value.length) {
      return false;
    }
    let n = 0;
    for (const p in value) {
      // value[p].content = _.compact(value[p].content)
      if (value[p].name !== '' && value[p].content.length !== 0) {
        n += 1;
      }
      if (value[p].name === '' && value[p].content.length === 0) {
        // value.splice(p, 1)
      }
    }
    if (n) {
      return true;
    }
    return false;
  },
};

const rules = {
  uw_title: [{ validator: checkProductTitle, trigger: ['blur', 'change'] }],
  image_urls: [{ validator: checkProductUpload, trigger: ['blur', 'change'] }],
  user_bank: [{ validator: checkBank, trigger: ['blur'] }],
  user_bank_no: [{ validator: checkBankId, trigger: ['blur'] }],
  name: [{ validator: checkName, trigger: ['blur', 'change'] }],
  nickname: [{ validator: nickName, trigger: ['blur', 'change'] }],
  company_name: [{ validator: checkCompanyName, trigger: ['blur', 'change'] }],
  company_scale: [{ validator: checkCompanySize, trigger: ['blur', 'change'] }],
  user_name: [{ validator: checkMobileOrEmail, trigger: ['blur', 'change'] }],
  password: [{ validator: checkPass, trigger: ['blur', 'change'] }],
  user_pass: [{ validator: checkPass, trigger: ['blur', 'change'] }],
  rep_password: [{ validator: checkPass2, trigger: ['blur', 'change'] }],
  mobile: [{ validator: checkMobile, trigger: ['blur', 'change'] }],
  code: [{ validator: checkCode, trigger: ['blur', 'change'] }],
  email: [{ validator: checkEmail, trigger: ['blur', 'change'] }],
  work_exp: [{ validator: checkExperience, trigger: ['blur', 'change'] }],
  adept_type: [{ validator: checkAbility, trigger: ['blur', 'change'] }],
  company_picture: [
    { validator: checkCompanyPic, trigger: ['blur', 'change'] },
  ],
  auth_file_url: [{ validator: checkID, trigger: ['blur', 'change'] }],
  remitter_company_name: [
    { validator: checkRemitterName, trigger: ['blur', 'change'] },
  ],
  remitter_name: [
    { validator: checkRemitterName, trigger: ['blur', 'change'] },
  ],
};

/**
 * 登录手机号验证
 * @type {RegExp}
 */
export const loginMobileReg = /^1[3584796]\d{9}$/;

/**
 * 登录密码验证(8~16位，支持大、小写字母、数字、特殊字符的其中二种及以上)
 * @type {RegExp}
 */
// export const loginPwdReg = /^(?!^\d+$)(?!^[A-Z]+$)(?!^[a-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/;
export const loginPwdReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,16}$/;

/**
 * 登录密码验证错误文案提示
 * @type {string}
 */
// export const loginPwdErrorMsg = '8-16位，大、小写字母、数字、符号至少2种';
export const loginPwdErrorMsg = '8-16位，大写字母、小写字母、数字各1种';

/**
 * 邮箱校验
 * @type {RegExp}
 */
export const emailReg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

/**
 * 验证码校验
 * @type {RegExp}
 */
export const verifyCodeReg = /^[0-9]{4}$/;

const validate = {
  loginPwdReg,
  rules,
  SingleCheck,
  inputNumber,
  handleAnchor,
};

export default validate;
